'use strict';

module.exports = {};
module.exports.Arc = require('./element.arc');
module.exports.Line = require('./element.line');
module.exports.Point = require('./element.point');
module.exports.Rectangle = require('./element.rectangle');



//////////////////
// WEBPACK FOOTER
// ./~/chart.js/src/elements/index.js
// module id = 22
// module chunks = 0